import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { clientFetch } from '~/lib/.client/fetch';
import { invariant } from '~/utils/invariant';
import { projectStore } from '~/lib/stores/project';

const claimProject = async () => {
  const projectId = projectStore.projectId.get();

  invariant(projectId);

  try {
    const response = await clientFetch(`/api/supabase/projects/${projectId}/claim`);

    const result = await response.json<{ success: string; error?: string } | string>();

    if (!response.ok || typeof result !== 'string') {
      const errorText = typeof result === 'string' ? result : result.error || response.statusText;
      toast.error(errorText);
      throw new Error(errorText);
    }

    window.open(result, '_self');
  } catch (error) {
    toast.error(error instanceof Error ? error.message : `${error}`);
  }
};

export const useClaimProject = () => {
  return useMutation({
    mutationFn: claimProject,
  });
};
